/* eslint-disable import/no-unresolved */
import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import StrapModal from './StrapModal';
import Container from '../../VuexyDesign/atoms/Container';
import styles from '../../style/scss/modules/HeroSection.module.scss';
import { useIsDesktop } from '../../style/constants';
// eslint-disable-next-line import/order

export function HeroSection() {
  const { t } = useTranslation('howItWorks');
  const isDesktop = useIsDesktop();

  return (
    <>
      <div
        className={styles.heroBanner}
        style={{
          background: "url('/static/images/how-it-works-banner.webp')",
        }}
      >
        <div className={styles.overlay} />
        <Container className="z-1 position-relative">
          <h1
            className={`text-white font-weight-bolder ${
              isDesktop ? 'display-3' : 'display-5'
            }`}
          >
            {t('howItWorks:howItWorks')}
          </h1>
          <span
            className={`custom-font-text-small-normal text-white ${
              isDesktop ? 'w-50' : 'w-100'
            } pb-1`}
          >
            {t('howItWorks:virppDesc') as string}
          </span>
          <div className="d-flex align-items-center">
            <StrapModal />
          </div>
        </Container>
      </div>
    </>
  );
}

export default HeroSection;
